import * as React from 'react';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useISUContext, Levels } from '../pages/Gui/gui';
import { Lev } from '../rows'
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';


export default function LevelMenu() {
  const isu = useISUContext()

  const handleLevClick = (event: React.ChangeEvent<HTMLInputElement>, level: Lev) => {
    console.log(event.target.checked)
    const checked = event.target.checked
    isu.setLevels((levels: Levels) => {
      return ({
        ...levels,
        [level]: checked
      })
    })
  }

  return (
    <React.Fragment>
      <FormControlLabel control={<Switch checked={isu.levels.lev0} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        handleLevClick(event, "lev0")
      }} />} label="Lev0" />
      <FormControlLabel control={<Switch checked={isu.levels.lev1} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        handleLevClick(event, "lev1")
      }} />} label="Lev1" />
      <FormControlLabel control={<Switch checked={isu.levels.lev2} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        handleLevClick(event, "lev2")
      }} />} label="Lev2" />
    </React.Fragment>
  );
}
